import React, { useContext } from "react";
import Delete from "../Delete/DeletePopup";
import { popupcontext } from "../../../context/Popupscontext";
import Display from "./Table Actions/Display";
import Link from "./Table Actions/Link";
import { useDispatch, useSelector } from "react-redux";
import { CiLogin } from "react-icons/ci";
import axios from "axios";
import { setUserInf } from "../../../Redux/service/Users/UsersSlice";
import { filtrationcontext } from "../../../context/Filtercontext";

export default function TableActions({
  vehicleId,
  vehicleuniqueId,
  DriverId,
  userId,
  subuserId,
  notifiyid,
  subcatid,
  GroupId,
  type,
  name,
  role,
  login,
  expired,
}) {
  const { handleShow } = useContext(popupcontext);
  const { setLoader } = useContext(filtrationcontext);
  const dispatch = useDispatch();
  const inf = useSelector((state) => state.users.user);
  const handleEditClick = () => {
    if (vehicleId) {
      handleShow("editForm", "vehicles", vehicleId);
    }
    if (DriverId) {
      handleShow("editForm", "drivers", DriverId);
    }
    if (userId) {
      handleShow("editForm", "users", userId);
    }
    if (subuserId) {
      handleShow("editForm", "users", subuserId);
    }
    if (notifiyid) {
      handleShow("editForm", "notifications", notifiyid);
    }
    if (GroupId) {
      handleShow("editForm", "groups", GroupId);
    }
  };

  const handleDeleteClick = () => {
    if (DriverId) {
      handleShow("deleteItem", "drivers", DriverId);
    }
    if (vehicleId) {
      handleShow("deleteItem", "vehicles", vehicleId);
    }
    if (userId) {
      handleShow("deleteItem", "users", userId);
    }
    if (subuserId) {
      handleShow("deleteItem", "subusers", subuserId);
    }
    if (notifiyid) {
      handleShow("deleteItem", "notifications", notifiyid);
    }
    if (GroupId) {
      handleShow("deleteItem", "groups", GroupId);
    }
  };
  const checkIdType = () => {
    if (vehicleuniqueId) {
      return vehicleuniqueId;
    } else if (userId) {
      return userId;
    } else if (subuserId) {
      return subuserId;
    }
  };
  const checkType = () => {
    if (vehicleId) {
      return "vehicles";
    } else if (userId) {
      return "users";
    } else if (subuserId) {
      return "subusers";
    }
  };
  const body = new URLSearchParams();
  const twoDaysLater = new Date(
    Date.now() + 2 * 24 * 60 * 60 * 1000
  ).toISOString();

  body.append("expiration", twoDaysLater);
  const quickLogin = async () => {
    try {
      const getSession = await axios.get(
        `${process.env.REACT_APP_API_URL}/session/${
          userId ? userId : subuserId
        }`,
        {
          withCredentials: true,
        }
      );
      if (getSession?.data) {
        const getSessionToken = await axios.post(
          `${process.env.REACT_APP_API_URL}/session/token`,
          body.toString(),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
            withCredentials: true,
          }
        );
        if (getSessionToken?.data) {
          setLoader(true);
          dispatch(setUserInf(getSession?.data));
          localStorage.setItem("token", getSessionToken?.data);
          window.location.replace(
            "https://dev.softsprint.ae/frontend2/dashboard"
          );
        }
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  return (
    <div className="table-element bg-transparent">
      <div className="d-flex table-actions ">
        {login && expired && role !== "Readonly" && (
          <CiLogin
            onClick={quickLogin}
            size={20}
            cursor="pointer"
            title="login"
          />
        )}
        {type === "link" &&
          (inf.administrator === true ||
            inf.deviceReadonly === true ||
            inf.deviceLimit > 0 ||
            inf.userLimit > 0) && (
            <>
              <Link
                id={checkIdType()}
                name={name}
                type={checkType()}
                role={role}
              />
            </>
          )}
        {type !== "display-off" && (
          <Display
            vehicleId={vehicleId}
            DriverId={DriverId}
            userId={userId}
            subuserId={subuserId}
            subcatid={subcatid}
            type={type}
          />
        )}
        {(inf.administrator === true ||
          inf.deviceLimit > 0 ||
          inf.userLimit > 0) && (
          <img
            role="button"
            src={`${process.env.PUBLIC_URL}/assets/Edit.svg`}
            alt="edit"
            onClick={handleEditClick}
            title="edit"
          />
        )}
        {(inf.administrator === true ||
          inf.deviceLimit > 0 ||
          inf.userLimit > 0) && (
          <Delete
            vehicleId={vehicleId}
            driverId={DriverId}
            userId={userId}
            subuserId={subuserId}
            notifiyid={notifiyid}
            GroupId={GroupId}
            handleDeleteClick={handleDeleteClick}
          />
        )}
      </div>
    </div>
  );
}
